 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"contract-v2":"contract-v2","admin":"admin","aliBey":"aliBey","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","user":"user","einmalig":"einmalig","habit":"habit","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"7a4c6ee1","chunk-0637e8e6":"3ac0b433","chunk-8aedfcda":"92adb07e","chunk-1a7d3fee":"34b119e6","chunk-1c81a122":"4b361acc","chunk-1d2e3766":"36709c3d","chunk-1447a746":"d36378f0","chunk-1a812538":"4eb25fe8","chunk-41aa1ba0":"6b9744b0","chunk-38352eb4":"caecae14","chunk-4354930d":"831556bd","chunk-447bd5a3":"a735bc02","chunk-2674db68":"4f84c4b6","chunk-483001c6":"d430a248","chunk-4cf70380":"fdcff2a5","chunk-505b5877":"c1af32f0","chunk-728e9aea":"81367510","chunk-94e14e52":"28e101a0","chunk-9826f532":"dcc7231e","chunk-d6e7dbea":"1d36eba9","chunk-f03f81fa":"9ecb0d9a","chunk-27a66c4e":"b6b232ea","chunk-7d2de34a":"37302109","contract-v2":"f3aed8f3","chunk-1e90651e":"9cf00be5","chunk-20f88ac6":"1a541803","chunk-217be9fa":"4eed72a2","admin":"25a1d46b","aliBey":"e7774e90","chunk-35408208":"d8429b83","chunk-1fb712dd":"67eeffca","chunk-715ed311":"42e082ce","dashboard":"7da1ed49","workouts":"3b9af4d6","chunk-6f564565":"608cb199","habit~nutrition":"f177cb18","nutrition":"87358be9","chunk-2d216f56":"5478984d","chunk-5d752f00":"ab85eeee","chunk-90fff2c4":"b794904d","chunk-b1de7e32":"8928306a","HomeNew.vue":"ea428d3a","chunk-3ef0055f":"5745d6a8","chunk-69c05e07":"a59b5d0a","user":"5c78ba66","chunk-6d8032cf":"ccd0cb00","chunk-b067410a":"3dc4a508","chunk-ef2249dc":"92d13441","chunk-fd7ca6de":"eedb2ab1","chunk-c4953526":"b2cd0b19","einmalig":"6d285536","habit":"83096d28","chunk-28d824b1":"6ceac4c7","chunk-2c17ccc7":"aa52b0a1","chunk-2d0abe58":"cb79b1c2","chunk-2d0ae56b":"da7c86ae","chunk-2d0dda10":"fc094788","chunk-2d0ac1cd":"5f1bffde","shop":"c07ff6fb","chunk-32d00dc6":"2f2c6a3b","chunk-35f42bac":"b9cea346","chunk-3adb5cf8":"c9625d91","chunk-3cc4f14e":"3a89c0df","chunk-3e175f3a":"0d192ad2","chunk-40f278fa":"398401e9","chat":"f960091e","chunk-6e83591c":"22ec3898","social":"1a239a27","deviceManagement":"2b1de708","event":"ab27c521","chunk-421dbbdc":"b06b4d75","chunk-dd6bd1de":"73456953","chunk-f0425560":"1c291595","chunk-ff3f9d62":"4374b075","chunk-57e5a315":"6f3c935c","chunk-5b7aaeed":"131a23bb","chunk-5dff41d6":"a262f87b","chunk-613e6a72":"1fb3c558","chunk-6890bbe5":"37567659","chunk-3a62fc42":"1d63c278","chunk-6f31c152":"53b58a4d","chunk-70f221fc":"2e146b15","chunk-726839ae":"a8e1a936","chunk-8015e132":"d4a62b26","chunk-ad763448":"22b6d124","chunk-b221966a":"a2a31498","chunk-d50be17a":"2611d337","chunk-ddb595f4":"dee5428a","chunk-e12df96c":"f3b22a6f","chunk-e38c2688":"931571dc","chunk-b42459f0":"2987b719","gf":"dea81afb","friends":"c184791e","live-quiz":"ca55f47d","live-quiz-host":"618987f2","live-quiz-manage":"41ae8d25","payment":"09903989","redirection":"3acbed28","chunk-2d209639":"94c15c44","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-59b2e543":"6cf6c8f0","chunk-2d0c13c4":"7813a997","trainerpoint-live":"68e70a16","chunk-816d4dc0":"7baf118f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04a70578":1,"chunk-0637e8e6":1,"chunk-8aedfcda":1,"chunk-1a7d3fee":1,"chunk-1c81a122":1,"chunk-1d2e3766":1,"chunk-1447a746":1,"chunk-1a812538":1,"chunk-38352eb4":1,"chunk-4354930d":1,"chunk-447bd5a3":1,"chunk-2674db68":1,"chunk-483001c6":1,"chunk-4cf70380":1,"chunk-505b5877":1,"chunk-728e9aea":1,"chunk-94e14e52":1,"chunk-9826f532":1,"chunk-f03f81fa":1,"chunk-27a66c4e":1,"chunk-7d2de34a":1,"contract-v2":1,"chunk-1e90651e":1,"chunk-20f88ac6":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-35408208":1,"chunk-1fb712dd":1,"chunk-715ed311":1,"dashboard":1,"workouts":1,"chunk-6f564565":1,"habit~nutrition":1,"nutrition":1,"chunk-5d752f00":1,"chunk-90fff2c4":1,"chunk-b1de7e32":1,"HomeNew.vue":1,"chunk-3ef0055f":1,"chunk-69c05e07":1,"user":1,"chunk-6d8032cf":1,"chunk-b067410a":1,"chunk-ef2249dc":1,"chunk-fd7ca6de":1,"chunk-c4953526":1,"einmalig":1,"habit":1,"chunk-28d824b1":1,"chunk-2c17ccc7":1,"shop":1,"chunk-32d00dc6":1,"chunk-35f42bac":1,"chunk-3adb5cf8":1,"chunk-3cc4f14e":1,"chunk-3e175f3a":1,"chunk-40f278fa":1,"chat":1,"social":1,"deviceManagement":1,"event":1,"chunk-421dbbdc":1,"chunk-dd6bd1de":1,"chunk-f0425560":1,"chunk-ff3f9d62":1,"chunk-57e5a315":1,"chunk-5b7aaeed":1,"chunk-5dff41d6":1,"chunk-613e6a72":1,"chunk-6890bbe5":1,"chunk-3a62fc42":1,"chunk-6f31c152":1,"chunk-70f221fc":1,"chunk-726839ae":1,"chunk-8015e132":1,"chunk-ad763448":1,"chunk-b221966a":1,"chunk-d50be17a":1,"chunk-ddb595f4":1,"chunk-e12df96c":1,"chunk-e38c2688":1,"chunk-b42459f0":1,"gf":1,"friends":1,"live-quiz":1,"live-quiz-host":1,"live-quiz-manage":1,"trainerpoint-live":1,"chunk-816d4dc0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"contract-v2":"contract-v2","admin":"admin","aliBey":"aliBey","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","user":"user","einmalig":"einmalig","habit":"habit","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","live-quiz":"live-quiz","live-quiz-host":"live-quiz-host","live-quiz-manage":"live-quiz-manage","payment":"payment","redirection":"redirection","trainerpoint-live":"trainerpoint-live"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"d888e6e3","chunk-0637e8e6":"7e857e5e","chunk-8aedfcda":"4eb0deb2","chunk-1a7d3fee":"1eeb5770","chunk-1c81a122":"f543d584","chunk-1d2e3766":"5ee2c0e1","chunk-1447a746":"c9fe281c","chunk-1a812538":"70f60110","chunk-41aa1ba0":"31d6cfe0","chunk-38352eb4":"10395e6d","chunk-4354930d":"c740b4af","chunk-447bd5a3":"d5d361c6","chunk-2674db68":"77ef6084","chunk-483001c6":"884b0e31","chunk-4cf70380":"d4a8c6a9","chunk-505b5877":"b0d8115f","chunk-728e9aea":"97541cbf","chunk-94e14e52":"2a59fb3e","chunk-9826f532":"1e86cea9","chunk-d6e7dbea":"31d6cfe0","chunk-f03f81fa":"350a1df7","chunk-27a66c4e":"c4ddac59","chunk-7d2de34a":"504ccee7","contract-v2":"ff349b99","chunk-1e90651e":"f95702ee","chunk-20f88ac6":"af48a7cb","chunk-217be9fa":"fd8c3217","admin":"4fd301a5","aliBey":"d5f8cca3","chunk-35408208":"65727138","chunk-1fb712dd":"66a1c861","chunk-715ed311":"6f137c18","dashboard":"a252f477","workouts":"643b6f33","chunk-6f564565":"50798865","habit~nutrition":"551557c5","nutrition":"3f18c82e","chunk-2d216f56":"31d6cfe0","chunk-5d752f00":"26db51fb","chunk-90fff2c4":"d9fc8c5f","chunk-b1de7e32":"fca5342d","HomeNew.vue":"ae2a9d62","chunk-3ef0055f":"ed0f3c30","chunk-69c05e07":"b13bc959","user":"fc147414","chunk-6d8032cf":"63f80147","chunk-b067410a":"b4b6f499","chunk-ef2249dc":"38cdad1c","chunk-fd7ca6de":"42016920","chunk-c4953526":"7abdf4c8","einmalig":"cc9b3599","habit":"346ce143","chunk-28d824b1":"211ed81c","chunk-2c17ccc7":"6670cb88","chunk-2d0abe58":"31d6cfe0","chunk-2d0ae56b":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d0ac1cd":"31d6cfe0","shop":"b224513d","chunk-32d00dc6":"e345f5a8","chunk-35f42bac":"144faf14","chunk-3adb5cf8":"07e59f58","chunk-3cc4f14e":"c7a4d223","chunk-3e175f3a":"4e463851","chunk-40f278fa":"9e01e709","chat":"9562146f","chunk-6e83591c":"31d6cfe0","social":"d92bd277","deviceManagement":"23584837","event":"d8b22b17","chunk-421dbbdc":"877dce51","chunk-dd6bd1de":"a90b8d3e","chunk-f0425560":"24571b99","chunk-ff3f9d62":"878934c7","chunk-57e5a315":"5894b40d","chunk-5b7aaeed":"89f0e141","chunk-5dff41d6":"0e3c4884","chunk-613e6a72":"3fa4f906","chunk-6890bbe5":"fbccfb1b","chunk-3a62fc42":"f1945e3c","chunk-6f31c152":"2a10cb05","chunk-70f221fc":"9d6fbaee","chunk-726839ae":"3fdd1937","chunk-8015e132":"c66fd981","chunk-ad763448":"7c109428","chunk-b221966a":"9abdd2cf","chunk-d50be17a":"5c500477","chunk-ddb595f4":"2837fba7","chunk-e12df96c":"cc24835d","chunk-e38c2688":"f8d3e502","chunk-b42459f0":"902a8fc4","gf":"41cebc21","friends":"2d95a385","live-quiz":"b897871b","live-quiz-host":"5b27bf15","live-quiz-manage":"d45c2eda","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-2d209639":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-59b2e543":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","trainerpoint-live":"1fb51549","chunk-816d4dc0":"022d1cd6"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
